import { Workspace } from "@/db/schema";
import Image from "next/image";

export function OrganizationLogoImage({ workspace }: { workspace: Workspace }) {
  return (
    <div className="flex items-center gap-3 p-2 overflow-hidden shrink">
      <div className="relative h-8 w-8 flex-none shrink-0 select-none">
        <Image
          fill
          src={
            "https://" +
            process.env.NEXT_PUBLIC_CLOUDFRONT_ID! +
            ".cloudfront.net/" +
            workspace.imageId
          }
          alt={workspace.name!}
          className="rounded-sm object-cover select-none"
        />
      </div>
      <p className="hidden sm:inline-block font-semibold text-[13px] whitespace-nowrap shrink">
        {workspace.name}
      </p>
    </div>
  );
}
